<!--客户管理 第三方供货关系管理-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="margin: 0"
          label-suffix="：">
          <el-form-item label="供应商名称">
            <el-select size="medium" filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.SUPPLIER_ID" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择客户" :clearable="true">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点分组">
            <el-select size="medium" filterable v-model="searchForm.GROUP_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projectGroup" :key="item.GROUP_ID" :label="item.PROJECT_GROUP"
                :value="item.GROUP_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" @click="filtrate()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">新增配送关系</el-button>
        <el-button size="medium" @click="() => { importRelationDialog = true }">导入供货关系</el-button>
        <el-button size="medium" @click="showCopySupplyRelationDialog">复制供应关系</el-button>
        <el-button size="medium" @click="() => { 批量导入供应产品信息模态框 = true }" v-if="是区间价格模式">批量导入供应产品信息</el-button>
        <downloadJsonToExcel :header="导出供应关系标头" fileName="releationManage.xlsx" @click="导出供应关系()"
          ref="downloadJsonToExcel" text="导出" :disabled="true">
        </downloadJsonToExcel>
        <tooltip-button :disabled="Boolean(this.checkedArray.length)" buttonText="批量解除供应关系" tipContent="请先勾选要解除的供应关系"
          @click="batchDeleteSupplyRelationship">
        </tooltip-button>

        <el-button size="medium" @click="批量解除供应单品()">批量解除供应单品</el-button>
        <tooltip-button :disabled="hasSelected && areTheSelectedRelationshipTypesTheSame" buttonText="新增商品供应关系"
          :tipContent="batchAddProductTip" @click="batchAddSupplyProduct">
        </tooltip-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top: 20px" ref="multipleTable"
          @selection-change="onSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="关系ID" prop="ID" width="80"></el-table-column>
          <el-table-column label="客户" prop="TC_NAME"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="第三方供应商" prop="SUPPLIER_NAME"></el-table-column>
          <el-table-column label="供货类型" prop="BE_MASTER">
            <template slot-scope="scope">
              <el-tag>{{ showMaster[scope.row.BE_MASTER] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="当期结算扣点" prop="CURRENT_DP"></el-table-column>
          <el-table-column label="下期结算扣点" prop="NEXT_DP"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="openEdit(scope.row)" type="text">修改</el-button>
              <el-button @click="openDetail(scope.row)" type="text">供应商品</el-button>
              <el-button @click="delReleation(scope.row)" type="text">解除供应</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
      <!-- 新增模态框 -->
      <el-dialog title="新增供应关系" center :visible.sync="addReleationFormVisible" width="400px"
        :close-on-click-modal="false">
        <el-form size="small" ref="addReleationForm" :model="addReleationForm" :label-width="formLableWidth"
          label-suffix="：">
          <el-form-item label="项目点">
            <el-select filterable v-model="addReleationForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商">
            <el-select filterable v-model="addReleationForm.SUPPLIER_ID" placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.SUPPLIER_ID" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配送方类型">
            <el-select filterable v-model="addReleationForm.BE_MASTER" placeholder="请选择" clearable>
              <el-option label="主配送方" :value="'1'"></el-option>
              <el-option label="副配送方" :value="'0'"></el-option>
              <el-option label="DS供应商" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当期结算扣点" v-if="addReleationForm.BE_MASTER != 2">
            <el-input v-model="addReleationForm.CURRENT_DP" style="width:95%">
            </el-input>
          </el-form-item>
          <el-form-item label="下期结算扣点" v-if="addReleationForm.BE_MASTER != 2">
            <el-input v-model="addReleationForm.NEXT_DP" style="width:95%">
            </el-input>
          </el-form-item>
          <el-form-item label="下期生效时间" v-if="addReleationForm.BE_MASTER != 2">
            <el-date-picker v-model="addReleationForm.NEXT_EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('addReleationForm')">取 消</el-button>
          <el-button size="small" @click="submitAdd('addReleationForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改供货类型 -->
      <el-dialog title="修改供应关系" center :visible.sync="editReleationFormVisible" width="400px"
        :close-on-click-modal="false">
        <el-form size="small" ref="editReleationForm" :model="editReleationForm" :label-width="formLableWidth"
          label-suffix="：">
          <el-form-item label="配送方类型">
            <el-select filterable v-model="editReleationForm.BE_MASTER" placeholder="请选择" clearable>
              <el-option label="主配送方" value="1"></el-option>
              <el-option label="副配送方" value="0"></el-option>
              <el-option label="DS供应商" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当期结算扣点" v-if="editReleationForm.BE_MASTER != 2">
            <el-input v-model="editReleationForm.CURRENT_DP" style="width:95%">
            </el-input>
          </el-form-item>
          <el-form-item label="下期结算扣点" v-if="editReleationForm.BE_MASTER != 2">
            <el-input v-model="editReleationForm.NEXT_DP" style="width:95%">
            </el-input>
          </el-form-item>
          <el-form-item label="下期生效时间" v-if="editReleationForm.BE_MASTER != 2">
            <el-date-picker v-model="editReleationForm.NEXT_EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('editReleationForm')">取 消</el-button>
          <el-button size="small" @click="submitEdit('editReleationForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 导入供货关系 -->
      <el-dialog title="导入供货关系" center :visible.sync="importRelationDialog" width="600px">
        <el-form ref="importRelationForm" v-model="importRelationForm">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
            :on-remove="handleRemove" name="tmp" accept=".xls, .xlsx" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <el-form-item>
            <span @click="downLoadTemp" style="color:#409EFF">点此下载导入模板</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close">取 消</el-button>
          <el-button size="small" @click="submitImport">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 复制供应关系 -->
      <el-dialog title="复制供应关系" center :visible.sync="copySupplyRelationDialogVisible" width="450px">
        <el-form ref="copySupplyRelationForm" v-model="copySupplyRelationForm" label-suffix="：">
          <el-form-item label="复制维度" :label-width="formLableWidth">
            <el-radio-group v-model="copySupplyRelationForm.copyAspect">
              <el-radio :label="0">项目点维度</el-radio>
              <el-radio :label="1">供应商维度</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="目标供应商" v-show="copySupplyRelationForm.copyAspect === 1" :label-width="formLableWidth">
            <el-select size="medium" filterable v-model="copySupplyRelationForm.SUPPLIER_ID" placeholder="请选择"
              clearable>
              <el-option v-for="item in supplierList" :key="item.SUPPLIER_ID" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" v-show="copySupplyRelationForm.copyAspect === 0" :label-width="formLableWidth">
            <el-select size="medium" filterable v-model="copySupplyRelationForm.TC_ID" @change="queryProjectId"
              placeholder="请选择" clearable>
              <el-option v-for="item in TC_LIST" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目标项目点" v-show="copySupplyRelationForm.copyAspect === 0" :label-width="formLableWidth">
            <el-select size="medium" filterable v-model="copySupplyRelationForm.PROJECT_ID" placeholder="请选择" clearable
              multiple collapse-tags @change="changeSelect" @remove-tag="removeTag">
              <el-option label="全选" value="全选"></el-option>
              <el-option v-for="item in targetProject" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复制类型" :label-width="formLableWidth">
            <el-radio-group v-model="copySupplyRelationForm.copyType">
              <el-radio :label="1">复制产品</el-radio>
              <el-radio :label="0">仅复制供应关系</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="copySupplyRelationDialogVisible = false">取 消</el-button>
          <el-button size="small" @click="submitCopySupplyRelationForm()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="复制供应关系错误" center :visible.sync="errorPresentationFormVisible" width="500px"
        :close-on-click-modal="false">
        <el-table border stripe :data="errorData" style="margin-top: 20px" ref="multipleTable">
          <el-table-column label="项目点名称" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="错误原因" prop="REASON"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="errorPresentationFormVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 批量导入供应产品信息模态框 -->
      <el-dialog :visible.sync="批量导入供应产品信息模态框" title="批量导入供应产品信息" width="400px" center>
        <el-form>
          <upload-excel-to-json @change="(e) => 批量导入供应产品信息获取数据(e)"
            :option="{ header: ['ID', 'PRODUCT_CODE', 'START_DATE', 'END_DATE', 'CURRENT_DP', 'NEXT_DP', 'NEXT_EFFECTIVE_DATE'] }"
            templateUrl="https://service.linkda.com.cn/file/templates/批量导入第三方供应产品信息模板.xlsx" ref="uploadExcelToJson">
          </upload-excel-to-json>
        </el-form>
        <div slot="footer" style="text-align: center">
          <el-button class="operate-btn" @click="关闭批量导入供应产品信息模态框()">取消</el-button>
          <tooltip-button :disabled="Boolean(批量导入供应产品信息列表[0])" buttonText="确认" tipContent="请先选择上传文件"
            buttonClass="operate-btn" @click="确认批量导入供应产品信息()">
          </tooltip-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="批量解除供应单品模态框" title="批量解除供应单品" width="500px" center>
        <el-form label-suffix="：">
          <el-form-item label-width="120px" label="文件">
            <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
              :on-remove="handleRemove" name="tmp" accept=".xls, .xlsx" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <p style="color:#66b1ff" @click="downLoadTmp">点击下载模板</p>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center">
          <el-button class="operate-btn" @click="批量解除供应单品模态框 = false">取消</el-button>
          <el-button class="operate-btn" @click="确认批量解除供应单品()">确认</el-button>

        </div>
      </el-dialog>

      <el-dialog title="新增供应商品" center :visible.sync="addSupplyProductDialogVisible" width="500px"
        :close-on-click-modal="false">
        <el-form size="small" ref="addSupplyProductForm" :model="addSupplyProductForm" :label-width="formLableWidth"
          label-suffix="：">
          <el-form-item label="添加方式">
            <el-switch style="width: 95%" v-model="addSupplyProductForm.showFlag" active-text="按产品名新增"
              inactive-text="按产品编码新增">
            </el-switch>
          </el-form-item>
          <el-form-item label="产品" v-show="addSupplyProductForm.showFlag">
            <el-select filterable v-model="addSupplyProductForm.PRODUCT_CODE" placeholder="请选择" clearable
              style="width: 95%">
              <el-option v-for="item in productList" :label="item.PRODUCT_NAME" :value="item.PRODUCT_CODE + ''"
                :key="item.PRODUCT_CODE">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品编码" v-show="!addSupplyProductForm.showFlag">
            <el-input v-model="addSupplyProductForm.PRODUCT_CODE" placeholder="请输入产品编码" clearable style="width: 95%">
            </el-input>
          </el-form-item>
          <el-form-item label="产品供应日期" v-if="价格模式 == 2">
            <el-date-picker v-model="addSupplyProductForm.START_END" align="right" type="daterange" placeholder="选择日期范围"
              value-format="yyyy-MM-dd" style="width: 95%">
            </el-date-picker>
          </el-form-item>
          <template v-if="areTheSelectedRelationshipTypesXF">
            <el-form-item label="当期结算扣点">
              <el-input v-model="addSupplyProductForm.CURRENT_DP" style="width:95%">
              </el-input>
            </el-form-item>
            <el-form-item label="下期结算扣点">
              <el-input v-model="addSupplyProductForm.NEXT_DP" style="width:95%">
              </el-input>
            </el-form-item>
            <el-form-item label="下期生效时间">
              <el-date-picker v-model="addSupplyProductForm.NEXT_EFFECTIVE_DATE" align="right" type="date"
                placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false" style="width:95%">
              </el-date-picker>
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeSupplyProduct()">取 消</el-button>
          <el-button size="small" @click="submitSupplyProduct()">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import {
  getAllReleationFun, delReleationFun, getAllReleationSupplier, addReleationFun, editReleationFun,
} from 'api/customerManage';
import { haveXMDFun, selectTCFun } from 'api/sellOrder';
import { getClientGroupFun } from 'api/systemSetting';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      导出供应关系标头: {
        ID: '关系ID',
        TC_NAME: '客户',
        PROJECT_NAME: '订单项目点',
        SUPPLIER_NAME: '第三方供应商',
        BE_MASTER: '供货类型',
        CURRENT_DP: '当期结算扣点',
        NEXT_DP: '下期结算扣点',
      },
      formLabelWidth: '150px',
      projectGroup: [],
      errorData: [], // 复制供应关系出错
      TC_LIST: [],
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      searchForm: {},
      targetProject: [],
      points: [],
      companys: [],
      supplierList: [],
      addReleationForm: {},
      addReleationFormVisible: false,
      editReleationFormVisible: false,
      editReleationForm: {},
      showMaster: ['副配送方', '主配送方', 'DS供应商'],
      formLableWidth: '120px',
      importRelationDialog: false,
      importRelationForm: {},
      file_name: '',
      fileList: [],
      errorPresentationFormVisible: false,
      copySupplyRelationDialogVisible: false,
      copySupplyRelationForm: {
        TC_ID: '',
        copyAspect: 0,
        copyType: 1,
        PROJECT_ID: [],
        SUPPLIER_ID: '',
      },
      批量导入供应产品信息模态框: false,
      批量导入供应产品信息列表: [],
      批量导入供应产品信息表格列宽: [10, 20, 14, 14, 14, 14, 14, 100],
      批量导入供应产品信息列名对象: {},
      价格模式: Number(sessionStorage.getItem('PRICE_MODE')),
      checkedArray: [],
      批量解除供应单品模态框: false,
      addSupplyProductForm: {
        showFlag: true,
      },
      addSupplyProductDialogVisible: false,
      productList: [],
      productInfo: {},
    };
  },
  created() {
    if (this.第三方供货关系管理存储数据) {
      this.searchForm = this.第三方供货关系管理存储数据.CONDITION;
      this.currentPage = this.第三方供货关系管理存储数据.CURRENT_PAGE;
      this.TOTAL_COUNT = this.第三方供货关系管理存储数据.TOTAL_COUNT;
    } else {
      this.currentPage = 1;
    }
    this.queryTitle();
    this.querySupplier();
    this.queryData();
    this.queryCustomer();
    this.queryTable();
  },
  computed: {
    // 上一次 搜索存储的条件
    第三方供货关系管理存储数据() {
      return this.$store.state.第三方供货关系管理存储数据;
    },
    是区间价格模式() {
      return this.价格模式 == 2;
    },
    hasSelected() {
      return this.checkedArray.length > 0;
    },
    areTheSelectedRelationshipTypesTheSame() {
      return this.areTheSelectedRelationshipTypesXF || this.checkedArray.every(({ BE_MASTER }) => BE_MASTER == 2);
    },
    areTheSelectedRelationshipTypesXF() {
      return this.checkedArray.every(({ BE_MASTER }) => ['0', '1'].includes(BE_MASTER));
    },
    batchAddProductTip() {
      if (!this.hasSelected) {
        return '请先选择要添加商品的供应关系';
      }
      if (!this.areTheSelectedRelationshipTypesTheSame) {
        return '所选供应关系类型不一致，请选择相同的供应关系类型';
      }
      return '';
    },
  },
  methods: {
    batchAddSupplyProduct() {
      this.addSupplyProductForm.BE_MASTER = this.checkedArray[0].BE_MASTER;
      if (this.checkedArray.map(({ ID }) => ID).sort().join(',') in this.productInfo) {
        this.productList = this.productInfo[this.checkedArray.map(({ ID }) => ID).sort().join(',')];

        this.addSupplyProductDialogVisible = true;
      } else this.queryProduct();
    },
    queryProduct() {
      const params = {
        SERVICE_ID: '10178',
        OTYPE: 22,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        DATA_LIST: this.checkedArray.map(({ ID, SUPPLIER_ID, PROJECT_ID }) => ({ ID, SUPPLIER_ID, PROJECT_ID })),
        PRICE_MODE: this.价格模式,
      };
      http.post(params).then((result) => {
        this.productList = result;
        if (result.length !== 0) {
          this.productInfo[this.checkedArray.map(({ ID }) => ID).sort().join(',')] = result;
          this.addSupplyProductDialogVisible = true;
        } else {
          this.$message.show({ text: '所勾选供应关系没有可以批量添加的产品', type: 'warning' });
        }
      });
    },
    closeSupplyProduct() {
      this.addSupplyProductForm = { showFlag: this.addSupplyProductForm.showFlag };
      this.addSupplyProductDialogVisible = false;
    },
    submitSupplyProduct() {
      if (!this.addSupplyProductForm.PRODUCT_CODE) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
      if (!this.addSupplyProductForm.showFlag) {
        if (!validation.产品编码验证(this.addSupplyProductForm.PRODUCT_CODE)) {
          this.$message.show({ text: '请输入正确产品编码', type: 'warning' });
          return false;
        }
      }
      if (!this.check('addSupplyProductForm')) {
        return false;
      }
      const params = {
        SERVICE_ID: '10178',
        OTYPE: 23,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        DATA_LIST: this.checkedArray.map(({ ID, SUPPLIER_ID, PROJECT_ID }) => ({ ID, SUPPLIER_ID, PROJECT_ID })),
        PRODUCT_CODE: this.addSupplyProductForm.PRODUCT_CODE,
        PRICE_MODE: this.价格模式,
      };
      if (this.areTheSelectedRelationshipTypesXF) {
        params.CURRENT_DP = this.addSupplyProductForm.CURRENT_DP;
        params.NEXT_DP = this.addSupplyProductForm.NEXT_DP;
        params.NEXT_EFFECTIVE_DATE = this.addSupplyProductForm.NEXT_EFFECTIVE_DATE;
      }
      if (this.价格模式 == 2) {
        if (this.addSupplyProductForm.START_END && this.addSupplyProductForm.START_END[0]) {
          [params.P2_START_DAY, params.P2_END_DAY] = [...this.addSupplyProductForm.START_END];
        } else {
          this.$message.show({ text: '请选择产品供应日期', type: 'warning' });
          return false;
        }
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.closeSupplyProduct();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导入模板下载
    downLoadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/supplied_products_temp.xlsx';
    },
    确认批量解除供应单品() {
      if (!this.file_name) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10178',
        OTYPE: 21,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.file_name,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '导入成功', type: 'success' });
        this.fileList = [];
        this.file_name = '';
        this.批量解除供应单品模态框 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    批量解除供应单品() {
      this.批量解除供应单品模态框 = true;
    },
    onSelectionChange(val) {
      this.checkedArray = val;
    },
    batchDeleteSupplyRelationship() {
      this.$confirm('确认解除选中的第三方供货关系吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const errorList = [];
        for (const RELEATION_ID of this.checkedArray.map(({ ID }) => ID)) {
          if (RELEATION_ID) {
            try {
              await delReleationFun({ RELEATION_ID });
            } catch (err) {
              errorList.push(err);
            }
          }
        }
        if (errorList.length) {
          this.$message.show({ text: `部分第三方供货关系解除失败:${errorList.join(',')}`, type: 'error' });
        } else {
          this.$message.show({ text: '批量解除成功', type: 'success' });
        }
        this.queryData();
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    // el-select 选中值发生变化时触发，val为目前选中的值
    changeSelect(val) {
      const end = val[val.length - 1];
      if (!val.includes('全选') && val.length === this.targetProject.length) {
        val.unshift('全选');
      } else if (val.includes('全选') && val.length == 1) {
        this.targetProject.map((item) => {
          val.push(item.PROJECT_ID);
        });
      } else if (val.includes('全选') && val.length - 1 < this.targetProject.length && end == '全选') {
        val = [];
        this.targetProject.map((item) => {
          val.push(item.PROJECT_ID);
        });
        val.unshift('全选');
      } else if (val.includes('全选') && val.length - 1 < this.targetProject.length) {
        val = val.filter((item) => item !== '全选');
      }
      // 注意，加上  this.value = val，确保勾选值同步
      this.copySupplyRelationForm.PROJECT_ID = val;
    },
    // 多选模式下移除tag时触发,val为移除的tag值
    removeTag(val) {
      if (val === '全选') {
        this.copySupplyRelationForm.PROJECT_ID = [];
      }
    },
    queryProjectId() {
      this.copySupplyRelationForm.PROJECT_ID = [];
      if (this.copySupplyRelationForm.TC_ID) {
        this.targetProject = this.points.filter(({ TC_ID }) => TC_ID === this.copySupplyRelationForm.TC_ID);
      } else {
        this.targetProject = [...this.points];
      }
    },
    submitCopySupplyRelationForm() {
      let params = {};
      // 产品1 供应关系0 项目点0 供应商 1
      if (this.copySupplyRelationForm.copyAspect === 0 && this.copySupplyRelationForm.PROJECT_ID.length === 0) {
        this.$message.show({ text: '请选择目标项目点', type: 'warning' });
        return;
      }
      if (this.copySupplyRelationForm.copyAspect === 1 && !this.copySupplyRelationForm.SUPPLIER_ID) {
        this.$message.show({ text: '请选择目标供应商', type: 'warning' });
        return;
      }
      if (this.copySupplyRelationForm.copyAspect === 0 && this.copySupplyRelationForm.PROJECT_ID.length > 0) {
        this.copySupplyRelationDialogVisible = false;
        params.ORIRIN_LIST = this.$refs.multipleTable.selection.map(({ GYS_ID, PROJECT_ID, SUPPLIER_ID }) => this.copySupplyRelationForm.PROJECT_ID.filter((item) => item !== '全选').map((TO_PROJECT_ID) => ({
          GYS_ID, PROJECT_ID, SUPPLIER_ID, TO_PROJECT_ID,
        }))).flatMap((item) => item);
        if (this.copySupplyRelationForm.copyType === 1) {
          params = {
            SERVICE_ID: '10178',
            OTYPE: 19,
            ...params,
          };
        } else if (this.copySupplyRelationForm.copyType === 0) {
          params = {
            SERVICE_ID: '10178',
            OTYPE: 17,
            ...params,
          };
        }
        http.post(params).then((result) => {
          if (!result.length) {
            this.$message.show({
              text: '复制成功',
              type: 'success',
            });
            this.queryData();
            this.copySupplyRelationForm.TC_ID = '';
            this.copySupplyRelationForm.PROJECT_ID = [];
          } else {
            this.errorData = result;
            this.$message.show({ text: '部分错误', type: 'warning' });
            this.errorPresentationFormVisible = true;
            this.copySupplyRelationForm.TC_ID = '';
            this.copySupplyRelationForm.PROJECT_ID = [];
            this.queryData();
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
      if (this.copySupplyRelationForm.copyAspect === 1 && this.copySupplyRelationForm.SUPPLIER_ID) {
        params.ORIRIN_LIST = this.$refs.multipleTable.selection.map(({ GYS_ID, PROJECT_ID, SUPPLIER_ID }) => ({
          GYS_ID, PROJECT_ID, SUPPLIER_ID, TO_SUPPLIER_ID: this.copySupplyRelationForm.SUPPLIER_ID,
        }));
        if (this.copySupplyRelationForm.copyType === 1) {
          params = {
            SERVICE_ID: '10178',
            OTYPE: 18,
            ...params,
          };
        } else if (this.copySupplyRelationForm.copyType === 0) {
          params = {
            SERVICE_ID: '10178',
            OTYPE: 16,
            ...params,
          };
        }
        http.post(params).then((result) => {
          this.$message.show({ text: '复制成功', type: 'success' });
          this.copySupplyRelationDialogVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 拉取项目点分组
    queryTable() {
      getClientGroupFun()
        .then((result) => {
          this.projectGroup = util.listRemoveDuplicates(result);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 打开复制供应关系模态框
    showCopySupplyRelationDialog() {
      if (this.$refs.multipleTable.selection.length === 0) {
        this.$message.show({ text: '请先勾选需要复制的供应关系', type: 'warning' });
        return;
      }
      this.copySupplyRelationDialogVisible = true;
    },
    filtrate() {
      this.currentPage = 1;
      this.queryData();
    },
    async 导出供应关系() {
      const params = {
        SERVICE_ID: '10178',
        OTYPE: 4,
        GYS_ID: sessionStorage.getItem('tcId'),
        PAGESIZE: 9999999,
        PAGEINDEX: 0,
      };
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.GROUP_ID) {
        params.GROUP_ID = Number(this.searchForm.GROUP_ID);
      }
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = Number(this.searchForm.TC_COMPANY);
      }
      await http.post(params).then((result) => {
        if (result.length > 0) {
          const downloadArray = result[1].list.map(({
            ID, TC_NAME, PROJECT_NAME, SUPPLIER_NAME, BE_MASTER, CURRENT_DP, NEXT_DP,
          }) => ({
            ID: String(ID), // 关系ID
            TC_NAME: String(TC_NAME), // 客户
            PROJECT_NAME: String(PROJECT_NAME), // 订单项目点
            SUPPLIER_NAME: String(SUPPLIER_NAME), // 第三方供应商
            BE_MASTER: this.showMaster[BE_MASTER], // 供货类型
            // showMaster: ['副配送方', '主配送方', 'DS供应商'],
            CURRENT_DP: Number(CURRENT_DP), // 当期结算扣点
            NEXT_DP: Number(NEXT_DP), // 下期结算扣点
          }));
          this.$refs.downloadJsonToExcel.download(downloadArray);
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取客户
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = this.$util.listRemoveDuplicates(result[0].company);
        } else {
          this.companys = [];
          this.customers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.GROUP_ID) {
        params.GROUP_ID = Number(this.searchForm.GROUP_ID);
      }
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = Number(this.searchForm.TC_COMPANY);
      }
      getAllReleationFun(params).then((result) => {
        if (result[1].list.length !== 0) {
          this.tableData = result[1].list.map((item) => Object.assign(item, { BE_MASTER: String(item.BE_MASTER) }));
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.$store.dispatch('设置第三方供货关系管理存储数据', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
          TOTAL_COUNT: this.totalCount,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    openDetail(row) {
      this.$router.push({ path: '/releationDetail/detail' });
      sessionStorage.setItem('SUPPLIER_ID', row.SUPPLIER_ID);
      sessionStorage.setItem('PROJECT_ID', row.PROJECT_ID);
      sessionStorage.setItem('BE_MASTER', row.BE_MASTER);
    },
    openAdd() {
      this.addReleationFormVisible = true;
    },
    submitAdd() {
      if (
        !this.addReleationForm.PROJECT_ID
        || !this.addReleationForm.SUPPLIER_ID
        || !this.addReleationForm.BE_MASTER
      ) {
        this.$message.show({ text: '确定前请填写完整', type: 'warning' });
        return false;
      }
      if (!this.check('addReleationForm')) {
        return false;
      }
      const params = {
        SUPPLIER_ID: this.addReleationForm.SUPPLIER_ID,
        PROJECT_ID: this.addReleationForm.PROJECT_ID,
        BE_MASTER: Number(this.addReleationForm.BE_MASTER),
      };
      if (this.addReleationForm.NEXT_EFFECTIVE_DATE) {
        params.NEXT_EFFECTIVE_DATE = this.addReleationForm.NEXT_EFFECTIVE_DATE;
      }
      if (this.addReleationForm.CURRENT_DP) {
        params.CURRENT_DP = this.addReleationForm.CURRENT_DP;
      }
      if (this.addReleationForm.NEXT_DP) {
        params.NEXT_DP = this.addReleationForm.NEXT_DP;
      }
      addReleationFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.addReleationForm = {};
        this.addReleationFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editReleationFormVisible = true;
      this.editReleationForm = row;
    },
    submitEdit() {
      if (!this.editReleationForm.BE_MASTER) {
        this.$message.show({ text: '确定前请填写完整', type: 'warning' });
        return false;
      }
      if (!this.check('editReleationForm')) {
        return false;
      }
      const params = {
        SUPPLIER_ID: this.editReleationForm.SUPPLIER_ID,
        PROJECT_ID: this.editReleationForm.PROJECT_ID,
        BE_MASTER: Number(this.editReleationForm.BE_MASTER),
        NEXT_EFFECTIVE_DATE: this.editReleationForm.NEXT_EFFECTIVE_DATE,
        CURRENT_DP: this.editReleationForm.CURRENT_DP,
        NEXT_DP: this.editReleationForm.NEXT_DP,
      };
      editReleationFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editReleationForm = {};
        this.editReleationFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    delReleation(row) {
      this.$confirm('确认解除第三方供货关系吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          RELEATION_ID: row.ID,
        };
        delReleationFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    queryTitle() {
      haveXMDFun().then((result) => {
        this.TC_LIST = result.length > 0 ? result[0].company.map(({ ID, AB_NAME }) => ({ ID, AB_NAME })) : [];
        this.points = result.length > 0 ? util.listRemoveDuplicates(result[0].project) : [];
        this.targetProject = [...this.points];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySupplier() {
      getAllReleationSupplier().then((result) => {
        if (result.length !== 0) {
          this.supplierList = util.listRemoveDuplicates(result);
        } else {
          this.supplierList = [];
        }
      });
    },
    close() {
      this.editReleationFormVisible = false;
      this.addReleationFormVisible = false;
      this.importRelationDialog = false;
      this.fileList = [];
      this.file_name = '';
      this.$refs.upload.clearFiles();
    },
    check(formName) {
      if (this.$refs[formName].model.BE_MASTER != 2) {
        if (
          !this.$refs[formName].model.CURRENT_DP || !validation.第三方扣点验证(this.$refs[formName].model.CURRENT_DP)
          || !this.$refs[formName].model.NEXT_DP || !validation.第三方扣点验证(this.$refs[formName].model.NEXT_DP)
          || !this.$refs[formName].model.NEXT_EFFECTIVE_DATE
        ) {
          this.$message.show({ text: '请正确填写扣点及生效日期，扣点须大于等于0小于100且至多两位小数', type: 'warning' });
          return false;
        }
      }
      return true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    submitImport() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10178',
            OTYPE: 15,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            FILE_NAME: this.file_name,
          };
          http.post(params).then((result) => {
            if (result.ERROR_LIST) {
              window.location.href = this.$util.getURLLocalHost(result.ERROR_LIST);
              this.$message.show({ text: '部分导入失败，详情请查看文件', type: 'warning' });
              this.fileList = [];
              this.file_name = '';
              this.$refs.upload.clearFiles();
            } else {
              this.queryData();
              this.$message.show({ text: '导入成功', type: 'success' });
              this.close();
            }
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.fileList = [];
            this.file_name = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    downLoadTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/DSSendReleation.xls';
    },
    async 批量导入供应产品信息获取数据(e) {
      const list = e.map(({
        ID, PRODUCT_CODE, START_DATE, END_DATE, CURRENT_DP, NEXT_DP, NEXT_EFFECTIVE_DATE,
      }) => ({
        ID, PRODUCT_CODE, START_DATE, END_DATE, CURRENT_DP, NEXT_DP, NEXT_EFFECTIVE_DATE,
      }));
      this.批量导入供应产品信息列名列表 = list.shift();
      let 验证通过 = true;
      for (const [index, item] of list.entries()) {
        const {
          ID, PRODUCT_CODE, START_DATE, END_DATE, CURRENT_DP, NEXT_DP, NEXT_EFFECTIVE_DATE,
        } = item;
        const REASON = [];
        if (!/^[1-9]\d*$/.test(ID)) {
          REASON.push('ID格式不正确');
        } else { item.ID = Number(ID); }
        if (!validation.产品编码验证(PRODUCT_CODE)) {
          REASON.push('产品编码格式不正确');
        }
        if (!validation.第三方扣点验证(CURRENT_DP)) {
          REASON.push('当前扣点须大于等于0小于100且至多两位小数');
        } else { item.CURRENT_DP = Number(CURRENT_DP); }
        if (!validation.第三方扣点验证(NEXT_DP)) {
          REASON.push('当前扣点须大于等于0小于100且至多两位小数');
        } else { item.NEXT_DP = Number(NEXT_DP); }
        if (!validation.dateValidate(START_DATE)) {
          REASON.push('开始日期格式不正确');
        }
        if (!validation.dateValidate(END_DATE)) {
          REASON.push('结束日期格式不正确');
        }
        if (!validation.dateValidate(NEXT_EFFECTIVE_DATE)) {
          REASON.push('下次生效日期格式不正确');
        }
        list[index].REASON = REASON.join('、');
        验证通过 = !list[index].REASON;
      }
      if (验证通过) {
        this.批量导入供应产品信息列表 = list.map((item, INDEX) => ({ ...item, INDEX }));
      } else {
        this.$message.show({ text: '导入失败，请检查数据格式', type: 'warning' });
        this.$refs.uploadExcelToJson.downloadErrorInfoFile({ ...this.批量导入供应产品信息列名列表, REASON: '错误原因' }, [...list], this.批量导入供应产品信息表格列宽);
        this.$refs.uploadExcelToJson.fileList = [];
      }
    },
    确认批量导入供应产品信息() {
      const params = {
        SERVICE_ID: '10178',
        OTYPE: 20,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        DATA_LIST: this.批量导入供应产品信息列表,
        PRICE_MODE: this.价格模式,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.$message.show({ text: '部分导入失败，详情请查看文件', type: 'warning' });
          this.$refs.uploadExcelToJson.downloadErrorInfoFile({ ...this.批量导入供应产品信息列名列表, REASON: '错误原因' }, [...result.map(({
            ID, PRODUCT_CODE, START_DATE, END_DATE, CURRENT_DP, NEXT_DP, NEXT_EFFECTIVE_DATE, REASON,
          }) => ({
            ID, PRODUCT_CODE, START_DATE, END_DATE, CURRENT_DP, NEXT_DP, NEXT_EFFECTIVE_DATE, REASON,
          }))], this.批量导入供应产品信息表格列宽);
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
          this.关闭批量导入供应产品信息模态框();
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    关闭批量导入供应产品信息模态框() {
      this.批量导入供应产品信息列表 = [];
      this.批量导入供应产品信息错误列表 = [];
      this.批量导入供应产品信息模态框 = false;
      this.$refs.uploadExcelToJson.fileList = [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/releationManage.vue